import { useSelector } from 'react-redux';

import type { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { getVehiclesList } from '../store/selectors';

const useMakeConfig = (make?: TMake) => {
  const vehiclesList = useSelector(getVehiclesList);

  if (!make) {
    return undefined;
  }

  return vehiclesList.find(makeConfig => makeConfig.make === make);
};

export { useMakeConfig };
